export default "__VITE_ASSET__OEpiRq_b__"